import { render, staticRenderFns } from "./Initial.vue?vue&type=template&id=2ec0f89f&scoped=true"
import script from "./Initial.vue?vue&type=script&lang=ts"
export * from "./Initial.vue?vue&type=script&lang=ts"
import style0 from "./Initial.vue?vue&type=style&index=0&id=2ec0f89f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec0f89f",
  null
  
)

export default component.exports